<div cdkTrapFocus aria-live="assertive">
  <div class="modal-header">
    <h3 class="modal-title" id="modal-header">
      @if (showIcon) {
        <i class="ico ico-info"></i>
      }
      {{ title | translate }}
    </h3>
  </div>
  @if (renderAsHtml) {
    <div class="modal-body" [innerHTML]="info | translate"></div>
  } @else {
    <div class="modal-body">{{ info | translate }}</div>
  }
  <div class="modal-footer" [ngStyle]="footerText ? { 'flex-wrap': 'nowrap' } : null">
    <span>
      {{ footerText }}
    </span>
    <button
      type="button"
      id="button_ok"
      class="modal_button_okay"
      (click)="closeModal()"
      attr.aria-label="{{ title }} Close"
      i18n="@@infoModalClose"
    >
      {{ buttonText }}
    </button>
  </div>
</div>
